import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 720.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,720.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M2930 4658 c-41 -5 -122 -25 -180 -44 -280 -93 -512 -314 -598 -569
-51 -151 -55 -176 -55 -325 0 -127 3 -158 28 -250 61 -230 195 -419 390 -551
75 -51 104 -65 193 -98 217 -80 446 -82 651 -5 126 47 246 117 235 136 -4 6
-3 8 4 4 19 -11 127 89 203 189 77 102 147 270 169 405 61 392 -120 787 -452
981 -109 64 -237 109 -357 124 -118 16 -125 16 -231 3z m138 -242 c13 -8 -9
-25 -193 -149 -154 -104 -223 -145 -355 -214 -25 -13 -52 -28 -60 -33 -37 -21
-103 -51 -106 -47 -7 7 67 140 104 187 72 92 161 163 297 234 l70 37 115 -3
c63 -2 121 -7 128 -12z m399 -129 c78 -61 153 -145 153 -172 0 -37 -61 -127
-139 -204 -227 -228 -773 -548 -1018 -596 -58 -12 -86 18 -122 133 -20 63 -45
172 -39 176 1 1 32 13 68 25 36 13 106 43 156 67 51 24 94 44 97 44 4 0 45 23
93 50 48 28 89 50 91 50 9 0 236 150 308 203 95 71 191 161 211 199 19 37 18
61 -6 91 -11 14 -20 28 -20 31 0 13 107 -49 167 -97z m293 -573 c0 -157 -18
-242 -76 -355 -70 -136 -174 -239 -310 -308 -124 -63 -196 -80 -337 -81 -125
0 -221 22 -324 74 l-66 33 44 7 c156 24 451 170 684 338 125 91 134 98 215
179 79 78 118 136 139 202 22 66 31 40 31 -89z"
          />
          <path
            d="M5835 4024 c-93 -48 -119 -113 -118 -304 0 -117 3 -142 22 -186 12
-29 34 -63 49 -77 38 -35 113 -59 165 -51 126 20 186 108 187 272 l0 62 -110
0 -110 0 0 -40 0 -40 55 0 55 0 0 -35 c0 -86 -67 -133 -143 -101 -53 21 -59
47 -55 218 3 133 5 149 24 168 48 49 145 25 159 -39 6 -30 8 -31 66 -31 66 0
69 4 44 63 -21 51 -64 97 -110 118 -50 23 -139 24 -180 3z"
          />
          <path
            d="M6720 4024 c-46 -20 -77 -50 -103 -99 -30 -56 -38 -298 -12 -374 52
-156 262 -196 358 -69 42 55 57 118 57 234 0 123 -13 184 -50 239 -51 75 -164
106 -250 69z m119 -95 c48 -17 64 -58 69 -173 5 -114 -9 -195 -40 -222 -32
-30 -101 -26 -135 9 -27 27 -28 30 -31 165 -4 155 3 183 50 212 38 23 44 24
87 9z"
          />
          <path
            d="M4260 3978 l0 -53 70 3 70 4 0 -256 0 -256 55 0 55 0 0 255 0 255 65
0 c36 0 65 4 66 10 0 6 1 27 2 48 l0 37 -191 3 -192 2 0 -52z"
          />
          <path
            d="M4720 3725 l0 -305 160 0 160 0 0 50 0 50 -110 0 -110 0 0 75 0 75
95 0 95 0 0 50 0 50 -95 0 -96 0 3 78 3 77 102 0 101 0 4 53 3 52 -157 0 -158
0 0 -305z"
          />
          <path
            d="M5125 3725 l0 -305 158 0 157 0 0 55 0 55 -100 0 -100 0 0 250 0 250
-57 0 -58 0 0 -305z"
          />
          <path
            d="M5515 4017 c-3 -7 -4 -143 -3 -302 l3 -290 53 -3 52 -3 0 305 0 306
-50 0 c-32 0 -52 -5 -55 -13z"
          />
          <path
            d="M6230 3725 l0 -305 158 0 157 0 -3 55 -4 55 -99 0 -99 0 0 250 0 250
-55 0 -55 0 0 -305z"
          />
          <path
            d="M7110 3725 l0 -305 134 0 c121 0 136 2 167 23 104 68 104 248 1 293
-2 1 11 15 28 32 26 27 30 37 30 87 0 74 -28 128 -80 155 -33 17 -59 20 -160
20 l-120 0 0 -305z m234 189 c20 -20 21 -83 0 -112 -12 -18 -25 -22 -70 -22
l-54 0 0 75 0 75 54 0 c36 0 60 -5 70 -16z m16 -254 c14 -14 20 -33 20 -63 0
-61 -23 -79 -97 -81 l-58 -1 -3 83 -3 82 61 0 c47 0 64 -4 80 -20z"
          />
          <path
            d="M7570 3725 l0 -305 165 0 165 0 0 50 0 50 -110 0 -110 0 0 75 0 75
90 0 90 0 0 50 0 50 -90 0 -90 0 0 81 0 80 105 -3 105 -3 0 53 0 52 -160 0
-160 0 0 -305z"
          />
          <path
            d="M8110 3988 c-7 -24 -45 -161 -85 -305 l-72 -263 57 0 58 0 13 60 13
60 88 0 c87 0 88 0 94 -27 20 -92 21 -93 80 -93 48 0 55 2 50 18 -3 9 -19 69
-35 132 -17 63 -51 193 -77 288 l-47 172 -62 0 -62 0 -13 -42z m130 -335 c0
-9 -19 -13 -61 -13 -49 0 -60 3 -56 14 3 8 18 65 33 127 l27 113 28 -114 c15
-63 28 -121 29 -127z"
          />
          <path
            d="M8480 3725 l0 -305 55 0 55 0 0 105 0 105 73 0 c88 0 126 20 159 82
33 63 32 176 -1 235 -38 67 -82 83 -224 83 l-117 0 0 -305z m233 187 c34 -37
34 -134 1 -167 -10 -10 -34 -15 -70 -15 l-54 0 0 100 0 100 53 0 c39 0 58 -5
70 -18z"
          />
          <path d="M8930 3725 l0 -305 53 0 52 0 0 305 0 305 -52 0 -53 0 0 -305z" />{' '}
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>; // Render logo without any link
  }

  // Render as external link
  return (
    <a
      href="https://www.aodata.ng"
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'block', width: '100%', height: '100%' }}
    >
      {logo}
    </a>
  );
}
